import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { UI_LAYERS } from '@keen.io/ui-core';
import { colors } from '@keen.io/colors';
export var Operator = styled.div.withConfig({
  displayName: "Filtersstyles__Operator",
  componentId: "keen-query-creator__sc-ep6vjt-0"
})(["&&&{margin:6px 0;}"]);
export var FiltersSettings = styled.div.withConfig({
  displayName: "Filtersstyles__FiltersSettings",
  componentId: "keen-query-creator__sc-ep6vjt-1"
})(["&&&{margin-bottom:20px;}"]);
export var ActionContainer = styled.div.withConfig({
  displayName: "Filtersstyles__ActionContainer",
  componentId: "keen-query-creator__sc-ep6vjt-2"
})(["&&&{", ";}"], function (props) {
  return props.hasSpacing && css(["margin-top:5px;"]);
});
export var Wrapper = styled.div.withConfig({
  displayName: "Filtersstyles__Wrapper",
  componentId: "keen-query-creator__sc-ep6vjt-3"
})(["&&&{position:relative;display:", ";}"], function (props) {
  return props.isDisabled ? 'inline-block' : 'block';
});
export var TooltipMotion = styled(motion.div).withConfig({
  displayName: "Filtersstyles__TooltipMotion",
  componentId: "keen-query-creator__sc-ep6vjt-4"
})(["&&&{position:absolute;left:100%;top:-50%;transform:translateX(10px) translateY(-10px);z-index:", ";}"], UI_LAYERS.tooltip);
export var Container = styled.div.withConfig({
  displayName: "Filtersstyles__Container",
  componentId: "keen-query-creator__sc-ep6vjt-5"
})(["&&&{padding:15px 0;border-top:1px solid ", ";border-bottom:1px solid ", ";}&&&:last-child{border-bottom:none;}"], colors.gray[300], colors.gray[300]);